<template>
        <TabView v-model:activeIndex="activeStep" class="col-12" style="min-height: 310px;">
            <TabPanel header="Old license" :disabled="true">
                <div class="grid flex">

                    <template v-if="oldLicenseIsExpired">
                        <div class="col-12">
                            The current license ended the <b>{{oldLicenseEndDate}}</b>
                        </div>
                        <div class="col-12">
                            The renewed license will start today, the <b>{{today}}</b>, if don't specify a different date.
                        </div>
                    </template>

                    <template v-else>
                        <div class="mt-2 col-12">
                            The current license will end the <b>{{oldLicenseEndDate}}</b>
                        </div>

                        <div class="col-6">
                            <div class="form-field">
                                <label for="terminate">Would you like to terminate it today?</label>
                                <Dropdown
                                    v-model="terminateOld"
                                    :options="[{label: 'Yes', value: true}, {label: 'No', value: false}]"
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder="Select Yes / No"
                                />
                            </div>
                        </div>
                        <div class="col-6">
                            <small>
                                If you don't specify a different starting date for the renewed license, it will start at the end
                                of this license (or today if it is already expired).
                            </small>
                        </div>

                    </template>

                    <div class="mt-2 col-12">
                        <div class="flex justify-content-end">
                            <Button
                                label="Next"
                                icon="pi pi-arrow-right"
                                class="p-button-secondary ml-2"
                                @click="activeStep = 1"
                            />

                            <Button
                                label="Cancel"
                                icon="pi pi-times"
                                class="p-button-warning ml-2"
                                @click="onCloseDialog"
                            />
                        </div>
                    </div>
                </div>

            </TabPanel>
            <TabPanel header="Start date renewed license" :disabled="true">
                <div class="grid">
                    <div class="col-6">
                        <div class="form-field">
                            <label for="startDate">Start Date</label>
                            <div class="flex justify-content-start">
                                <Calendar
                                    :showIcon="true"
                                    inputId="startDate"
                                    v-model="startDate"
                                    dateFormat="dd-mm-yy"
                                    :minDate="DateTime.now().toJSDate()"
                                />
                                <Button
                                    icon="pi pi-calendar-times"
                                    class="p-button-warning ml-2"
                                    @click="startDate = null"
                                    v-tooltip="'Reset start date to default'"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <small v-if="oldLicenseIsExpired">
                            The old license is already expired: the renewed license will start today (default behaviour)
                            or in the date that you specify here.
                        </small>
                    </div>

                    <div class="mt-2 col-12">
                        <div class="flex justify-content-end">
                            <Button
                                label="Previous"
                                icon="pi pi-arrow-left"
                                class="p-button-secondary ml-2"
                                @click="activeStep = 0"
                            />
                            <Button
                                label="Next"
                                icon="pi pi-arrow-right"
                                class="p-button-secondary ml-2"
                                @click="activeStep = 2"
                            />

                            <Button
                                label="Cancel"
                                icon="pi pi-times"
                                class="p-button-warning ml-2"
                                @click="onCloseDialog"
                            />
                        </div>
                    </div>
                </div>
            </TabPanel>
            <TabPanel header="Renewed license duration" :disabled="true">
                <div class="grid">

                    <div class="col-6">
                        <div class="form-field">
                            <label for="duration">Standard duration (number of months)</label>
                            <div class="flex justify-content-start">
                                <InputNumber
                                    id="duration"
                                    v-model="months"
                                    placeholder="Select standard duration (months)"
                                    :min="0" :max="9999"
                                    :useGrouping="false"
                                    suffix=" months"
                                />
                                <Button
                                    icon="pi pi-times"
                                    class="p-button-warning ml-1"
                                    @click="months = null"
                                    v-tooltip="'Reset months'"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="col-1 justify-content-center text-center align-items-center align-content-center">
                        <span>
                            <b>OR</b>
                        </span>
                    </div>

                    <div class="col-5">
                        <div class="form-field">
                            <label for="endDate">End Date</label>
                            <div class="flex justify-content-start">
                                <Calendar
                                    :showIcon="true"
                                    inputId="endDate"
                                    v-model="endDate"
                                    dateFormat="dd-mm-yy"
                                    :minDate="DateTime.now().toJSDate()"
                                    :disabled="months !== null"
                                />
                                <Button
                                    icon="pi pi-calendar-times"
                                    class="p-button-warning ml-1"
                                    :disabled="months !== null"
                                    @click="endDate = null"
                                    v-tooltip="'Reset start date to default'"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="mt-2 col-12">
                        <div class="flex justify-content-end">
                            <Button
                                label="Previous"
                                icon="pi pi-arrow-left"
                                class="p-button-secondary ml-2"
                                @click="activeStep = 1"
                            />

                            <Button
                                :disabled="(months == null && endDate == null) || (newLicense && newLicense.id > 0)"
                                label="Renew"
                                class="p-button-success ml-2"
                                icon="pi pi-bolt"
                                :loading="savingRenew"
                                @click="onRenewConfirm"
                            />

                            <Button
                                label="Cancel"
                                icon="pi pi-times"
                                class="p-button-warning ml-2"
                                @click="onCloseDialog"
                            />
                        </div>
                    </div>

                    <div class="form-field col-12" v-if="overlappingLicense">
                        <div class="border-orange-500 surface-overlay border-3 border-round font-bold m-0 p-2 flex justify-content-between">
                            <div class="text-center align-content-center">
                                Overlapping License!
                            </div>
                            <div class="flex align-content-end">
                                <Button
                                    icon="pi pi-times"
                                    class="p-button-rounded p-button-warning mr-2"
                                    v-tooltip="'Hide error'"
                                    @click="overlappingLicense = false" />
                            </div>
                        </div>
                        <div class="mt-2 grid">
                            <div class="col-12 flex align-items-center justify-content-center">
                                The Licence is overlapping the following:
                            </div>

                            <div class="form-field col-6">
                                <div class="text-500 font-medium">Product</div>
                                <div class="text-900 w-full md:flex-order-0 flex-order-1">
                                    {{overlappingLicenseData?.product?.description}}
                                </div>
                            </div>
                            <div class="form-field col-6">
                                <div class="text-500 font-medium">Start date</div>
                                <div class="text-900 w-full md:flex-order-0 flex-order-1">
                                    {{dateFormat(overlappingLicenseData?.start_date)}}
                                </div>
                                <div class="text-500 font-medium">End date</div>
                                <div class="text-900 w-full md:flex-order-0 flex-order-1">
                                    {{dateFormat(overlappingLicenseData?.end_date)}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-2 col-12" v-if="newLicense && newLicense.id > 0">

                        License renewed with id: {{newLicense.id}}!<br />

                        <Button
                            icon="pi pi-pencil"
                            class="p-button-success mr-2"
                            @click="goToNewLicense(newLicense.id)"
                            v-tooltip="'Edit new license'"
                            label="Open the new license"
                        />
                    </div>
                </div>
            </TabPanel>
        </TabView>

</template>

<script setup>


import { defineProps, defineEmits, ref, onMounted, computed } from 'vue';
import { DateTime } from 'luxon';
import GlobalRequest from '@/api/global-request';
import router from '@/router';

const emit = defineEmits(['hideDialog'])

const props = defineProps({
    id: {
        type: [String, Number],
        required: true,
    },
    currentLicenseEndDate: {
        type: [Object],
        required: true,
    },
    standardMonths: {
        type: [Number],
        required: true,
    }
})

const today = DateTime.now().endOf('day').setLocale('en-GB').toLocaleString({
    weekday: 'short',
    month: 'short',
    day: '2-digit',
    year: 'numeric',
})

const activeStep = ref(0)

const terminateOld = ref(false)
const startDate = ref(null)
const endDate = ref(null)
const months = ref(null)

const newLicense = ref(null)

const oldLicenseEndDate = ref('')

const savingRenew = ref(false)

const overlappingLicense = ref(false)
const overlappingLicenseData = ref({})

const oldLicenseIsExpired = computed(() => {
    const today = DateTime.now().endOf('day')
    const oldLicenseEndDate = props.currentLicenseEndDate?.endOf('day')
    console.log('today', oldLicenseEndDate.ts, today.ts)

    return oldLicenseEndDate.ts < today.ts
})

onMounted(() => {

    overlappingLicense.value = false
    overlappingLicenseData.value = {}

    oldLicenseEndDate.value = props.currentLicenseEndDate?.setLocale('en-GB').toLocaleString({
        weekday: 'short',
        month: 'short',
        day: '2-digit',
        year: 'numeric',
    })

    months.value = props.standardMonths
})

function onRenewConfirm() {

    overlappingLicense.value = false
    overlappingLicenseData.value = {}

    savingRenew.value = true

    let payload = {
        id: props.id,
    }

    if (terminateOld.value === true) {
        payload.terminate_old = true
    }

    if (startDate.value !== null) {
        payload.start_date = DateTime.fromJSDate(startDate.value).toFormat('y-LL-dd')
    }

    if (endDate.value !== null) {
        payload.end_date = DateTime.fromJSDate(endDate.value).toFormat('y-LL-dd')
    }

    if (months.value !== null) {
        payload.months = months.value
    }

    GlobalRequest.postRequest('/v2/licenses/renew' , payload)
        .then((response) => {
            console.log('response', response)

            if (Object.hasOwn(response, 'data')) {
                if (Object.hasOwn(response.data, 'new_license')) {
                    newLicense.value = response.data.new_license
                }
            }
        })
        .catch((result) => {
            if (result.status === 406) {
                console.log('onCreateNewLicense::result', result.data.data)

                const data = result.data.data.find(x=>x!==undefined);

                overlappingLicense.value = true
                overlappingLicenseData.value = data
            }
        })
        .finally(() => {
            savingRenew.value = false
        }
    )

}

function onCloseDialog() {
    emit('hideDialog')
}

function goToNewLicense(id) {
    router.push({path: `/license/edit/${id}`, replace: true})
    emit('hideDialog')
}

function dateFormat(date) {
    let jsDate = DateTime.fromSQL(date)
    if (!jsDate.isValid) {
        jsDate = DateTime.fromISO(date)
    }
    if (!jsDate.isValid) {
        jsDate = DateTime.fromFormat(date, 'yyyy-MM-ddTHH:mm:ss.SSS')
    }
    if (!jsDate.isValid) {
        return ''
    } else {
        return jsDate?.setLocale('en-GB').toLocaleString({
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        })
    }
}

</script>

<style scoped lang="scss">

.form-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
}

.form-field label {
    margin-bottom: 0.5rem;
}
</style>